var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconMenu = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 21,
  viewBox: "0 0 24 21",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#f26522",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.75 1.5h22.498a.75.75 0 0 0 0-1.5H.75a.75.75 0 0 0 0 1.5zM23.248 9H.75a.75.75 0 0 0 0 1.5h22.498a.75.75 0 0 0 0-1.5zM15.749 19h-15a.75.75 0 0 0 0 1.5h15a.75.75 0 0 0 0-1.5z"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_menu.f09d2515.svg";
export { ForwardRef as ReactComponent };